import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id,
    username,
    nickname,
    mobile,
    email,
    address,
    password,
    locked = false,
    roles = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.admin.save, {
        id,
        username,
        nickname,
        mobile,
        email,
        address,
        password,
        locked,
        roles,
    }, options);
    if (error) return { error, status };
    return content || { };
};
